// src/components/slack-connect-button/DefaultSlackConnectButton.tsx
import { useCallback } from "react";
import { useNovuUI } from "../../context/NovuUIContext.js";
import { Mounter } from "../Mounter.js";
import { jsx } from "react/jsx-runtime";
var DefaultSlackConnectButton = (props) => {
  const {
    integrationIdentifier,
    connectionIdentifier,
    subscriberId,
    context,
    contextHash,
    scope,
    connectionMode,
    autoLinkUser,
    onConnectSuccess,
    onConnectError,
    onDisconnectSuccess,
    onDisconnectError,
    connectLabel,
    connectedLabel
  } = props;
  const { novuUI } = useNovuUI();
  const mount = useCallback(
    (element) => {
      return novuUI.mountComponent({
        name: "SlackConnectButton",
        props: {
          integrationIdentifier,
          connectionIdentifier,
          subscriberId,
          context,
          contextHash,
          scope,
          connectionMode,
          autoLinkUser,
          onConnectSuccess,
          onConnectError,
          onDisconnectSuccess,
          onDisconnectError,
          connectLabel,
          connectedLabel
        },
        element
      });
    },
    [
      novuUI,
      integrationIdentifier,
      connectionIdentifier,
      subscriberId,
      context,
      contextHash,
      scope,
      connectionMode,
      autoLinkUser,
      onConnectSuccess,
      onConnectError,
      onDisconnectSuccess,
      onDisconnectError,
      connectLabel,
      connectedLabel
    ]
  );
  return /* @__PURE__ */ jsx(Mounter, { mount });
};
export {
  DefaultSlackConnectButton
};
//# sourceMappingURL=DefaultSlackConnectButton.js.map